import { render, staticRenderFns } from "./above-image.vue?vue&type=template&id=01b17a14"
import script from "./above-image.vue?vue&type=script&lang=js"
export * from "./above-image.vue?vue&type=script&lang=js"
import style0 from "./above-image.vue?vue&type=style&index=0&id=01b17a14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports